export const defaultValueLanguage = { value: 'all', label: 'All languages' }
export const defaultValueReplySource = { value: 'all', label: 'All sources' }
export const defaultValueIntent = { value: 'all', label: 'All intents' }
export const defaultFallbackIntent = 'Default Fallback Intent'
